module.exports = __webpack_public_path__ + "static/media/enicon-logo.18c939e8.png";